import React, { useContext, useEffect, useState } from 'react';
import {BsShop, BsPinMap, BsHouses } from "react-icons/bs";
import Button from './Button';
import { ModalContext } from '../context/ModalContext';
import axios from 'axios';

const WhatLookingFor = () => {
    const modalContext = useContext(ModalContext);
    const [whatLookingData, setWhatLooking] = useState({
        plots: '',
        rawhouses: '',
        commercial: ''
    });

    useEffect(() => {
        const fetchData = async () => {
        try {
            const res = await axios.get("/api/fetchwhatlooking"); // Adjust port if needed
            const fetchedData = res.data[0]; // Assuming data is an array
            setWhatLooking({
                plots: fetchedData.plots || '',
                rawhouses: fetchedData.rawhouses || '',
                commercial: fetchedData.commercial || '',
            });
            //setWhatLooking(mapped);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
        };
        fetchData();
    }, []);
    const whatLooking = [
        {
          id:1,
          icon:<BsPinMap />,
          heading:'Plots',
          content:whatLookingData.plots,
        },
        {
          id:2,
          icon:<BsHouses />,
          heading:'Raw Houses',
          content:whatLookingData.rawhouses,
        },
        {
          id:3,
          icon:<BsShop />,
          heading:'Commercial',
          content:whatLookingData.commercial,
        },
      ];

    return (
        <>
        <section className="what-looking-for relative py-12">
            {/* <div className='absolute right-0 bottom-0 h-full w-full'></div> */}
            <div className="container mx-auto z-10">
                <div className="flex text-center items-center justify-center w-3/5 md:w-2/4 mx-auto mb-7">
                    <div className="home-projects-head flex flex-col text-center items-center justify-center align-middle">
                        <h2 className="relative text-2xl leading-8 font-bold uppercase font-montserrat mb-2">
                        <span className="absolute top-1/2 -left-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                        <span className=' text-slate-500 font-thin'>What</span> are you looking for?
                        <span className="absolute top-1/2 -right-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                        </h2>
                    </div>
                </div>
                <div className='flex md:flex-row flex-col'>
                    <div className='w-full px-8 sm:px-0 py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 grid-flow-row auto-rows-auto gap-8'>
                    {whatLooking.map((item,i)=>{ 
                    return (
                    <div className='flex flex-col justify-start items-center align-middle px-5 py-7 bg-white text-gray-600 text-base rounded-xl box-shadow' key={item.id}>
                        <div className='text-4xl mb-5 text-blue-600'>{item.icon}</div>
                        <div className='text-xl font-semibold uppercase mb-4 text-gray-900'>{item.heading}</div>
                        <div className='text-center mb-5'>{item.content}</div>
                        <Button type='button' className='hover:bg-sky-950 hover:border-transparent hover:text-white' variant='slate' onClick={() => {
                            modalContext.setShowEnquiryPopup(true);
                        }}>Send Enquiry</Button>
                    </div>
                    )}
                    )}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default WhatLookingFor;
